import $ from "jquery";
import cryptojs from "crypto-js";

var sx = {};

sx.encrypt = function(word, keyStr) {
  if (sx.isNothingOrEmpty(keyStr)) {
    keyStr = 'ABGHNJHGSHUYG12';
  }
  var encrypted = cryptojs.AES.encrypt(word, keyStr);
  return encrypted.toString();
};

sx.decrypt = function(word, keyStr) {
  if (sx.isNothingOrEmpty(word)) {
    return word;
  }
  if (sx.isNothingOrEmpty(keyStr)) {
    keyStr = 'ABGHNJHGSHUYG12';
  }
  var decrypt = cryptojs.AES.decrypt(word, keyStr);
  return decrypt.toString(cryptojs.enc.Utf8);
};

sx.isNothingOrEmpty = function(obj) {
  if (obj === null || obj === undefined || obj === '') {
    return true
  } else {
    return false
  }
}

sx.toastWarning = function(msg) {
  sx.toast(msg, "warning");
};
sx.toastInfo = function(msg) {
  sx.toast(msg, "info");
};
sx.toastError = function(msg) {
  sx.toast(msg, "danger");
};
sx.toastSuccess = function(msg) {
  sx.toast(msg, "success");
};

sx.toast = function(msg, level) {
  var option = {
    delay: 3000
  };
  $(".toast").toast(option);
  $(".toast-body").html(msg);
  $(".toast-body").addClass("alert-" + level);

  $(".toast").toast("show");
};

sx.showWaiting = function() {
  $("#myWaiting").modal("show");
};

sx.hideWaiting = function() {
  setTimeout(function () {
    $("#myWaiting").modal("hide");
  }, 400);
};

sx.request = function(requrl, params, callback, callbackerr) {
  $.post(
    requrl,
    params,
    function(data, textStatus, jqXHR) {
      if (data.status === 'outdated') {
        sx.login(
          requrl,
          params,
          function(data) {
            callback(data);
          })
      } else if (data.status === 'tokenerr' || data.status === 'refetch') {
        callbackerr(data);
      } else {
        callback(data);
      }
    },
    "json"
  ).fail(function (jqXHR, textStatus, errorThrown) {
    console.log(errorThrown);
    localStorage.setItem('baseurl', 'https://cloud.salesmini.cn')
  });
};

sx.relogin = function(callback) {
  var username = localStorage.getItem('username')
  var password = localStorage.getItem('password')
  if (sx.isNothingOrEmpty(username) || sx.isNothingOrEmpty(password)) {
    return
  }
  var para = {
    username: username,
    password: sx.decrypt(password, ''),
    corpid: 40,
    bucketid: '17',
    token: ''
  }
  var baseurl = localStorage.getItem('baseurl') || 'https://cloud.salesmini.cn'
  sx.request(
    baseurl + '/app/account/login',
    para,
    function(result) {
      if (result.status === 'ok') {
        localStorage.setItem('token', result.data.token)
        callback();
      } else {
        console.log('The username and / or password is incorrect')
      }
    }
  )
}

sx.login = function(requrl, params, callback) {
  var username = localStorage.getItem('username')
  if (!username) {
    username = "guest"
  }
  var password = localStorage.getItem('password')
  if (!password) {
    password = "guest"
  } else {
    password = sx.decrypt(password, '')
  }
  var para = {
    username: username,
    password: password,
    corpid: 40,
    bucketid: '17',
    token: ''
  }
  var baseurl = localStorage.getItem('baseurl') || 'https://cloud.salesmini.cn'
  sx.request(
    baseurl + '/app/account/login',
    para,
    function(result) {
      if (result.status === 'ok') {
        localStorage.setItem('token', result.data.token)
        params.token = localStorage.getItem('token')
        sx.request(
          requrl,
          params,
          function(data) {
            if (data.status === 'ok') {
              callback(data);
            } else {
              console.log('The username and / or password is incorrect')
            }
          },
          function(result) {
            console.log("wrong")
          }
        )
      } else {
        callback(result);
        console.log('The username and / or password is incorrect')
      }
    },
    function(result) {
      console.log("wrong")
    }
  )
}

export default sx;
